__webpack_require__.p = "/MigraineNexus/";